import React, { createContext } from 'react';
import { FormContextValue } from './types';
import { useFormState } from './useFormState';

export const FormContext = createContext<FormContextValue<unknown> | null>(null);

export function FormProvider<T>({
  children,
  initialState,
}: React.PropsWithChildren<{ initialState?: T }>) {
  const contextValue = useFormState<T>(initialState);

  return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>;
}
